const TEAM_MEMBER_STATUS = {
  DECLINED: 'declined',
  MEMBER: 'member',
  PENDING: 'pending',
  REQUEST: 'request',
};

export default TEAM_MEMBER_STATUS;
